<template>
  <v-container fluid >
    <v-row no-gutters class="pa-0">
      <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
        <OpzstatItemsCRUD />
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import OpzstatItemsCRUD from './OpzstatItemsCRUD'

export default {
  name: 'betontvrtkaindex',
  data () {
    return {
      msg: '',
      lang: {},
      langC: {},
      locMonths: [],
      locYears: [],
      saving: false,
      postNew: false
    }
  },
  mounted () {

  },
  methods: {


  },
  computed: {

  },
  watch: {

  },
  components: {
    OpzstatItemsCRUD
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
